import CloseIcon from '@ordr-as/icons/CloseIcon';

const PanelCloseButton = ({ onClose }: { onClose: () => void }) => (
  <button
    className="flex-none w-6 h-6 rounded-full flex items-center justify-center text-brand-secondary hover:bg-grey-lightest"
    onClick={onClose}
    title="Hide panel"
  >
    <CloseIcon width={18} height={18} />
  </button>
);

export default PanelCloseButton;
